import React from 'react'

import { Box, Tooltip } from '@mui/material'
import { Share as ShareIcon } from '@mui/icons-material'

import { SmallLoadingButton } from '@edge/spark/ui-mui'

interface Props {
    loading?: boolean
    onShare?: () => void
    open?: boolean
    disabled?: boolean
}

const TOOLTIP_MESSAGE = 'Share all table results'

export const SharePdfAction: React.FC<Props> = ({ loading, open, onShare, disabled }: Props) => {
    return (
        <Tooltip title={TOOLTIP_MESSAGE}>
            <Box>
                <SmallLoadingButton
                    disabled={disabled}
                    loading={loading || open}
                    onClick={onShare}
                    startIcon={<ShareIcon />}
                >
                    Share
                </SmallLoadingButton>
            </Box>
        </Tooltip>
    )
}
